module.exports = __webpack_public_path__ + "static/media/FindMyWayDowntoYou_jacket.6ab01d3a.jpg";